import { dropdownValuesService } from "services";
interface Processor {
	id: string | number;
	name: string;
}

let requestCache: Processor[] | null = null;

const LoadProcessors = async search => {
	try {
		if (requestCache === null || search?.length === 0) {
			requestCache = await dropdownValuesService.getProcessors();
		}

		return {
			options: search
				? requestCache?.filter(item =>
						item?.name
							?.toLowerCase()
							?.includes(search?.toLowerCase()),
				  )
				: requestCache,
			hasMore: false,
		};
	} catch (error) {
		console.error("Error loading processors:", error);
		return { options: [] };
	}
};

const processorColumn = () => ({
	name: "processor",
	type: "select" as const,
	loadOptions: LoadProcessors,
	getOptionLabel: option => option.name,
	getOptionValue: option => option.id,
	placeholder: "Processor",
});

export default processorColumn;
